/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import './GameHot.scss'
function GameHot () {
  return (
    <section className='sec_hotgame'>
      <div className='heading'>
        <img src='/gamehot.png' alt='' />
      </div>
      <ul className='ul_hotgame'>
        <li>
          <a>
            <img src='/casino.png' alt='' />
          </a>
        </li>
        <li>
          <a>
            <img src='/thethao.png' alt='' />
          </a>
        </li>
        <li>
          <a>
            <img src='/xoso.png' alt='' />
          </a>
        </li>
        <li>
          <a>
            <img src='/banca.png' alt='' />
          </a>
        </li>
        <li>
          <a>
            <img src='/daga.png' alt='' />
          </a>
        </li>
      </ul>
    </section>
  )
}

export default GameHot
